import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3270cb38")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImageClipHandler = _resolveComponent("ImageClipHandler")
  const _component_ImageOutline = _resolveComponent("ImageOutline")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", {
    class: ["editable-element-image", { 'lock': _ctx.elementInfo.lock }],
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    }
  }, [
    _createVNode("div", {
      class: "rotate-wrapper",
      style: { transform: `rotate(${_ctx.elementInfo.rotate}deg)` }
    }, [
      (_ctx.isCliping)
        ? (_openBlock(), _createBlock(_component_ImageClipHandler, {
            key: 0,
            src: _ctx.elementInfo.src,
            clipData: _ctx.elementInfo.clip,
            width: _ctx.elementInfo.width,
            height: _ctx.elementInfo.height,
            top: _ctx.elementInfo.top,
            left: _ctx.elementInfo.left,
            clipPath: _ctx.clipShape.style,
            onClip: _cache[1] || (_cache[1] = range => _ctx.handleClip(range))
          }, null, 8, ["src", "clipData", "width", "height", "top", "left", "clipPath"]))
        : _withDirectives((_openBlock(), _createBlock("div", {
            key: 1,
            class: "element-content",
            style: {
          filter: _ctx.shadowStyle ? `drop-shadow(${_ctx.shadowStyle})` : '',
          transform: _ctx.flipStyle,
        },
            onMousedown: _cache[3] || (_cache[3] = $event => _ctx.handleSelectElement($event))
          }, [
            _createVNode(_component_ImageOutline, { elementInfo: _ctx.elementInfo }, null, 8, ["elementInfo"]),
            _createVNode("div", {
              class: "image-content",
              style: { clipPath: _ctx.clipShape.style }
            }, [
              _createVNode("img", {
                src: _ctx.elementInfo.src,
                draggable: false,
                style: {
              top: _ctx.imgPosition.top,
              left: _ctx.imgPosition.left,
              width: _ctx.imgPosition.width,
              height: _ctx.imgPosition.height,
              filter: _ctx.filter,
            },
                onDragstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                alt: ""
              }, null, 44, ["src"])
            ], 4)
          ], 36)), [
            [_directive_contextmenu, _ctx.contextmenus]
          ])
    ], 4)
  ], 6))
})